import React from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export default function CaretRightIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.46967 5.46967C8.76256 5.17678 9.23744 5.17678 9.53033 5.46967L14.8232 10.7626C14.8313 10.7706 14.8394 10.7788 14.8476 10.7869C14.9927 10.9319 15.1496 11.0887 15.2642 11.2388C15.3984 11.4148 15.5429 11.6665 15.5429 12C15.5429 12.3335 15.3984 12.5852 15.2642 12.7612C15.1496 12.9113 14.9927 13.0681 14.8476 13.2131C14.8394 13.2212 14.8313 13.2294 14.8232 13.2374L9.53033 18.5303C9.23744 18.8232 8.76256 18.8232 8.46967 18.5303C8.17678 18.2374 8.17678 17.7626 8.46967 17.4697L13.7626 12.1768C13.8326 12.1067 13.8894 12.0499 13.9377 12C13.8894 11.9501 13.8326 11.8933 13.7626 11.8232L8.46967 6.53033C8.17678 6.23744 8.17678 5.76256 8.46967 5.46967Z"
      />
    </SvgIcon>
  );
}
